"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _Help = require("../../components/Help");
var _hooks = require("./hooks");
const _excluded = ["useSelector", "useDispatch", "query"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HelpContainer = _ref => {
  let {
      useSelector,
      useDispatch,
      query
    } = _ref,
    helpComponentProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const helpUrl = (0, _hooks.useHelpUrl)({
    useSelector,
    useDispatch,
    query
  });
  return /*#__PURE__*/React.createElement(_Help.Help, (0, _extends2.default)({}, helpComponentProps, {
    helpUrl: helpUrl
  }));
};
exports.HelpContainer = HelpContainer;